'use strict';

const Item = require('../Item');

/**
 * @class
 * @hideconstructor
 * @extends HomeyAPIV3.Item
 * @memberof HomeyAPIV3.ManagerFlowToken
 */
class FlowToken extends Item {

  static transformGet(item) {
    item = super.transformGet(item);

    if (item.uri) {
      item.id = `${item.uri}:${item.id}`;
      delete item.uri;
    }

    // TODO: Remove when back-end has removed these properties.
    delete item.uriObj;
    delete item.ownerName; // Prepare for back-end change

    return item;
  }

  get uriObj() {
    console.warn('FlowToken.uriObj is deprecated.');
    return undefined;
  }

  get ownerName() {
    console.warn('FlowToken.ownerName is deprecated.');
    return undefined;
  }

}

module.exports = FlowToken;
